const MIN_CHARS = 1,
    MAX_CHARS = 255;

export function validateFormData(form) {
    const errors = [];

    for (let name of ['firstName', 'lastName']) {
        const value = form[name];

        if (!value || value.length < MIN_CHARS || value.length > MAX_CHARS) {
            errors.push(name);
        }
    }

    return errors;
}
